import { FormDataClass } from "../../../utils/formsSchema/FormDataClass";
import { DataTypes } from "json-schema-yup-transformer/dist/schema";
import { PublisherEnum } from "../../../graphqlExternal/generated";

export class GamCampaignFormDataClass extends FormDataClass {
    constructor(staffCreator = false) {
        super();
        this.fields = {
          ...this.getBasicDetails(),
          ...(staffCreator ? this.getUserDetailsFields() : {}),
        };
      }

      getUserDetailsFields() {
        return {
          packageOwnerEmail: {
            type: DataTypes.STRING,
            format: "email",
            inputFormat: "email",
            label: "Campaign Owner Email Address",
            placeholder: "Type the campaign owners email address",
            isRequired: true,
            default: "",
            errors: {
              required: "This field is required.",
              format: {
                email: "Please enter a valid email address.",
              },
            },
          },
        };
      }

      getBasicDetails() {
        return {
          name: {
            type: DataTypes.STRING,
            label: "Campaign Name",
            placeholder: "Type the name of the campaign",
            isRequired: true,
            default: "",
            errors: {
              required: "The campaign name is required.",
            },
          },
          startDate: {
            type: DataTypes.STRING,
            format: "date",
            label: "Start Date",
            isRequired: true,
            default: "",
            placeholder: "Choose Date",
            errors: {
              required: "Please specify a start date for the segment.",
            },
          },
          endDate: {
            type: [DataTypes.STRING, DataTypes.NULL],
            format: "date",
            label: "End Date",
            isRequired: false,
            default: null,
            placeholder: "Choose Date",
          },
          orderId: {
            type: DataTypes.STRING,
            label: "Order ID",
            placeholder: "Type the order ID",
            isRequired: true,
            default: "",
            errors: {
              required: "The order ID is required.",
            },
          },
          learnFromIds: {
            type: [DataTypes.ARRAY],
            items: {
              type: DataTypes.STRING,
              // enum: Object.values(InsightCategoryChoices),
            },
            isRequired: true,
            label: "Learn From IDs",
            placeholder: "Seperated with commas (no spaces)",
            default: [],
            minItems: 1,
            errors: {
              required: "The learn from IDs are required.",
            },
          },
          publisher: {
            type: DataTypes.STRING,
            enum: Object.values(PublisherEnum),
            default: PublisherEnum.NewsUk,
            label: "Publisher",
            isRequired: true,
            errors: {
              required: "Please select the publisher.",
            },
          },
          domains: {
            type: [DataTypes.ARRAY, DataTypes.NULL],
            items: {
              type: DataTypes.STRING,
              // enum: Object.values(InsightCategoryChoices),
            },
            isRequired: true,
            label: "Domains",
            placeholder: "Type or select domains",
            default: [],
            minItems: 1,
            errors: {
              required: "Please select at least one domain.",
            },
          },
        };
      }

}
